import React, { useState } from 'react';

interface CookieSettingsProps {
  onBack?: () => void;
}

const CookieSettings = ({ onBack }: CookieSettingsProps) => {
  const [settings, setSettings] = useState({
    essential: true, // Always enabled
    analytics: true,
    marketing: false,
    preferences: true
  });

  const handleToggle = (category: keyof typeof settings) => {
    if (category === 'essential') return; // Essential cookies cannot be disabled
    setSettings(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const saveSettings = () => {
    localStorage.setItem('beno-cookie-settings', JSON.stringify(settings));
    alert('Configurações salvas com sucesso!');
  };

  return (
    <div style={{ 
      backgroundColor: '#ffffff', 
      minHeight: '100vh',
      padding: '2rem 0'
    }}>
      <div className="container">
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '1rem',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              color: '#111827',
              marginBottom: '1rem'
            }}>
              Configurações de Cookies
            </h1>
            <p style={{ color: '#6b7280', fontSize: '1rem' }}>
              Gerencie suas preferências de cookies e privacidade
            </p>
          </div>

          {/* Content */}
          <div style={{ lineHeight: '1.6', color: '#374151' }}>
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                O que são cookies?
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Cookies são pequenos arquivos de texto armazenados no seu dispositivo que nos ajudam a melhorar sua experiência no site da Beno.
              </p>
            </section>

            {/* Cookie Categories */}
            <div style={{ marginBottom: '3rem' }}>
              {/* Essential Cookies */}
              <div style={{ 
                border: '1px solid #e5e7eb', 
                borderRadius: '0.5rem', 
                padding: '1.5rem',
                marginBottom: '1rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827' }}>
                    🔒 Cookies Essenciais
                  </h3>
                  <div style={{ 
                    background: '#10b981', 
                    color: 'white', 
                    padding: '0.25rem 0.75rem',
                    borderRadius: '0.25rem',
                    fontSize: '0.75rem',
                    fontWeight: 'bold'
                  }}>
                    SEMPRE ATIVO
                  </div>
                </div>
                <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  Necessários para o funcionamento básico do site. Não podem ser desativados.
                </p>
              </div>

              {/* Analytics Cookies */}
              <div style={{ 
                border: '1px solid #e5e7eb', 
                borderRadius: '0.5rem', 
                padding: '1.5rem',
                marginBottom: '1rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827' }}>
                    📊 Cookies de Análise
                  </h3>
                  <label style={{ 
                    position: 'relative',
                    display: 'inline-block',
                    width: '60px',
                    height: '34px'
                  }}>
                    <input
                      type="checkbox"
                      checked={settings.analytics}
                      onChange={() => handleToggle('analytics')}
                      style={{ opacity: 0, width: 0, height: 0 }}
                    />
                    <span style={{
                      position: 'absolute',
                      cursor: 'pointer',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: settings.analytics ? '#2563eb' : '#ccc',
                      transition: '0.4s',
                      borderRadius: '34px'
                    }}>
                      <span style={{
                        position: 'absolute',
                        content: '',
                        height: '26px',
                        width: '26px',
                        left: settings.analytics ? '30px' : '4px',
                        bottom: '4px',
                        backgroundColor: 'white',
                        transition: '0.4s',
                        borderRadius: '50%'
                      }}></span>
                    </span>
                  </label>
                </div>
                <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  Nos ajudam a entender como você usa nosso site para melhorar a experiência.
                </p>
              </div>

              {/* Marketing Cookies */}
              <div style={{ 
                border: '1px solid #e5e7eb', 
                borderRadius: '0.5rem', 
                padding: '1.5rem',
                marginBottom: '1rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827' }}>
                    🎯 Cookies de Marketing
                  </h3>
                  <label style={{ 
                    position: 'relative',
                    display: 'inline-block',
                    width: '60px',
                    height: '34px'
                  }}>
                    <input
                      type="checkbox"
                      checked={settings.marketing}
                      onChange={() => handleToggle('marketing')}
                      style={{ opacity: 0, width: 0, height: 0 }}
                    />
                    <span style={{
                      position: 'absolute',
                      cursor: 'pointer',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: settings.marketing ? '#2563eb' : '#ccc',
                      transition: '0.4s',
                      borderRadius: '34px'
                    }}>
                      <span style={{
                        position: 'absolute',
                        content: '',
                        height: '26px',
                        width: '26px',
                        left: settings.marketing ? '30px' : '4px',
                        bottom: '4px',
                        backgroundColor: 'white',
                        transition: '0.4s',
                        borderRadius: '50%'
                      }}></span>
                    </span>
                  </label>
                </div>
                <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  Usados para exibir anúncios relevantes baseados em seus interesses.
                </p>
              </div>

              {/* Preferences Cookies */}
              <div style={{ 
                border: '1px solid #e5e7eb', 
                borderRadius: '0.5rem', 
                padding: '1.5rem',
                marginBottom: '2rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827' }}>
                    ⚙️ Cookies de Preferências
                  </h3>
                  <label style={{ 
                    position: 'relative',
                    display: 'inline-block',
                    width: '60px',
                    height: '34px'
                  }}>
                    <input
                      type="checkbox"
                      checked={settings.preferences}
                      onChange={() => handleToggle('preferences')}
                      style={{ opacity: 0, width: 0, height: 0 }}
                    />
                    <span style={{
                      position: 'absolute',
                      cursor: 'pointer',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: settings.preferences ? '#2563eb' : '#ccc',
                      transition: '0.4s',
                      borderRadius: '34px'
                    }}>
                      <span style={{
                        position: 'absolute',
                        content: '',
                        height: '26px',
                        width: '26px',
                        left: settings.preferences ? '30px' : '4px',
                        bottom: '4px',
                        backgroundColor: 'white',
                        transition: '0.4s',
                        borderRadius: '50%'
                      }}></span>
                    </span>
                  </label>
                </div>
                <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  Lembram suas escolhas para personalizar sua experiência.
                </p>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={saveSettings}
                style={{
                  background: 'linear-gradient(45deg, #2563eb, #1d4ed8)',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                ✅ Salvar Configurações
              </button>
              
              <button 
                onClick={onBack || (() => window.history.back())}
                style={{
                  background: 'transparent',
                  color: '#6b7280',
                  border: '1px solid #d1d5db',
                  padding: '0.75rem 2rem',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                ← Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieSettings;